/**
 * No-operation (noop).
 *
 * @param {...any} args
 */
export function noop(...args) { }
/**
 * Whether two values are NOT equal.
 *
 * @param valueA
 * @param valueB
 */
export function notEqual(valueA, valueB) {
    // This ensures (valueB==NaN, valueA==NaN) always returns false.
    return valueB !== valueA && (valueB === valueB || valueA === valueA);
}
/**
 * Whether two values are equal.
 *
 * @param valueA
 * @param valueB
 */
export function equal(valueA, valueB) {
    return !notEqual(valueA, valueB);
}
/**
 * Checks if the given `value` is `null`.
 *
 * @param value The value to check.
 */
export function isNull(value) {
    return value === null;
}
/**
 * Checks if the given `value` is `undefined`.
 *
 * @param value - The value to check.
 */
export function isUndefined(value) {
    return typeof value === 'undefined';
}
/**
 * Checks if given `value` is `null` or `undefined`.
 *
 * @param value - The value to check.
 */
export function isNil(value) {
    return isNull(value) || isUndefined(value);
}
/**
 * Checks if the given `value` is classified as a `Object`.
 *
 * @param value - The value to check.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function isObject(value) {
    return (value === null || value === void 0 ? void 0 : value.constructor) === Object;
}
/**
 * Checks if the given `value` is classified as a `Number` object.
 *
 * @param value - The value to check.
 */
export function isNumber(value) {
    return (value === null || value === void 0 ? void 0 : value.constructor) === Number && !Number.isNaN(value);
}
/**
 * Checks if the given `value` is classified as a `String` object.
 *
 * @param value - The value to check.
 */
export function isString(value) {
    return (value === null || value === void 0 ? void 0 : value.constructor) === String;
}
/**
 * Checks if `value` is classified as a `Boolean` object.
 *
 * @param value - The value to check.
 */
export function isBoolean(value) {
    return (value === null || value === void 0 ? void 0 : value.constructor) === Boolean;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @param value - The value to check.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction(value) {
    return (value === null || value === void 0 ? void 0 : value.constructor) === Function || value instanceof Function;
}
/**
 * Checks if the given `value` is classified as an `Array` object.
 *
 * @param value - The value to check.
 */
export function isArray(value) {
    return Array.isArray(value);
}
